// Single confirm dialog on Quote Ready when warnings are active (grill decision:
// one dialog listing every fired warning per item, one "Offer anyway" — per-item
// acks rejected because repetition trains click-through).
export default function ConfirmOfferDialog({ hits, busy, onCancel, onConfirm }) {
    const byItem = new Map();
    for (const h of hits) {
        if (!byItem.has(h.itemIndex)) byItem.set(h.itemIndex, []);
        byItem.get(h.itemIndex).push(h);
    }

    return (
        <div className="modal-overlay">
            <div className="modal-content" onClick={e => e.stopPropagation()}>
                <div className="modal-header"><h2>Buying rules fired</h2><button className="modal-close" onClick={onCancel}>&times;</button></div>
                <div className="modal-body-scroll">
                    <p>This quote goes against the buying rules below. Sending it anyway is recorded as an override.</p>
                    {[...byItem.entries()].map(([idx, itemHits]) => (
                        <div key={idx} className="qa-confirm-item">
                            <div className="qa-confirm-item-name">#{idx + 1} {itemHits[0].itemName}</div>
                            {itemHits.map(h => <div key={h.ruleKey} className="qa-confirm-rule">{h.message}</div>)}
                        </div>
                    ))}
                </div>
                <div className="modal-footer" style={{ padding: 'var(--space-4)' }}>
                    <button className="btn btn-secondary" onClick={onCancel}>Cancel</button>
                    <button className="btn btn-quote-ready" onClick={onConfirm} disabled={busy}>{busy ? '…' : 'Offer anyway'}</button>
                </div>
            </div>
        </div>
    );
}
